module.exports = __webpack_public_path__ + "static/img/shop-style-3.23cd6ee8.png";